import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  IonBadge,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonIcon,
  IonText,
} from "@ionic/react";
import { calendarOutline, cardOutline, personOutline } from "ionicons/icons";

import "./styles/GroupLogCard.scss";
import { FormattedDate, FormattedTime } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import useLessonsByGroupLogId from "../../../../hooks/lessons/useLessonsByGroupLogId";

function isSubscriptionActive(from_date, to_date) {
  const now = new Date();
  return (
    now >= new Date(from_date.seconds * 1000) &&
    now <= new Date(to_date.seconds * 1000)
  );
}

function GroupLogCard({ data, className }) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const {
    data: lessonByPaymentData,
    error: lessonError,
    isLoading: isLoadingLessonData,
  } = useLessonsByGroupLogId(data.id, !isDetailsOpen);
  const {
    id,
    from_date,
    to_date,
    description,
    payment_date,
    payment_channel,
    full_name,
  } = data;

  console.log("data", data);
  const recoverData = {};
  const lessonsNotRecovered = [];


  if (data.deletedLessons && data.deletedLessons.length > 0) {
    for (const lesson of data.deletedLessons) {
      if (lesson.recovered_by) {
        recoverData[lesson.recovered_by.lesson_id] = lesson;
      } else {
        lessonsNotRecovered.push(lesson);
      }
    }
  }

  return (
    <IonCard
      key={id}
      style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
      className={className ? `GroupLogCard ${className}` : "GroupLogCard"}
    >
      <IonCardContent style={{ flex: 1, paddingLeft: "1rem" }}>
        <IonText>
          <h5>
            <IonIcon icon={calendarOutline}></IonIcon>
            <FormattedDate
              value={from_date._seconds * 1000}
              day="2-digit"
              month="2-digit"
              year="2-digit"
            />
            &nbsp;-&nbsp;
            <FormattedDate
              value={to_date._seconds * 1000}
              day="2-digit"
              month="2-digit"
              year="2-digit"
            />
          </h5>
          {isSubscriptionActive(from_date, to_date) && (
            <IonBadge color="success">Attivo</IonBadge>
          )}
          {!isSubscriptionActive(from_date, to_date) && (
            <IonBadge color="primary">Non attivo</IonBadge>
          )}
        </IonText>
        <IonCardTitle>{description}</IonCardTitle>
        <IonText>
          <h5>
            <IonIcon icon={personOutline}></IonIcon>
            {full_name}
          </h5>
        </IonText>
      </IonCardContent>
      <IonCardContent
        style={{
          flex: "0 1 auto",
          paddingLeft: "1rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <IonButton
          fill="clear"
          onClick={(e) => {
            e.stopPropagation();
            setIsDetailsOpen(!isDetailsOpen);
          }}
        >
          <FontAwesomeIcon
            icon={faChevronUp}
            style={{
              fontSize: "1.5em",
            }}
          />
        </IonButton>
      </IonCardContent>
      {isDetailsOpen && (
        <IonCardContent
          className="GroupLogCard__details"
          style={{
            flexBasis: "100%",
          }}
        >
          <h2>Diario lezioni</h2>
          <div key={data.id} className="GroupLogCard__lessons">
            <h5>
              {data.description}
              &nbsp;-&nbsp;(
              <FormattedDate
                value={data.from_date._seconds * 1000}
                day="2-digit"
                month="2-digit"
                year="2-digit"
              />
              &nbsp;-&nbsp;
              <FormattedDate
                value={data.to_date._seconds * 1000}
                day="2-digit"
                month="2-digit"
                year="2-digit"
              />
              )
            </h5>
            {data.lessons < data.minimum_lessons ? (
              <IonBadge color="danger">Lezioni da recuperare</IonBadge>
            ) : (
              ""
            )}
            <h6>
              Lezioni svolte{" "}
              <span className="GroupLogCard__lesson_number">
                {data.lessons || "-"}
              </span>{" "}
              su{" "}
              <span className="GroupLogCard__lesson_number">
                {data.minimum_lessons}
              </span>{" "}
              pianificate
            </h6>
            <ul>
              {(lessonByPaymentData || []).map((lesson) => (
                <li key={lesson.id}>
                  <FormattedDate
                    value={lesson.to_date.seconds * 1000}
                    day="2-digit"
                    month="2-digit"
                    year="2-digit"
                    weekday="long"
                  />
                  &nbsp;-&nbsp;
                  <FormattedTime
                    value={lesson.from_date.seconds * 1000}
                  />
                  {lesson.is_recover && (
                    <>
                      <IonText color="primary" style={{ fontWeight: "bold" }}>
                        &nbsp;R
                      </IonText>
                      {lesson.lesson_id in recoverData &&
                        lesson.lesson_id !== recoverData[lesson.lesson_id].id && (
                          <IonText color="primary" style={{ fontWeight: "bold", textDecoration: "line-through" }}>
                            <br />
                            <FormattedDate
                              value={recoverData[lesson.lesson_id].to_date._seconds * 1000}
                              day="2-digit"
                              month="2-digit"
                              year="2-digit"
                              weekday="long"
                            />
                            &nbsp;-&nbsp;
                            <FormattedTime
                              value={recoverData[lesson.lesson_id].from_date._seconds * 1000}
                            />
                          </IonText>
                        )}
                    </>
                  )}
                </li>
              ))}
              {(lessonsNotRecovered || []).map((lesson) => (
                <li key={lesson.id}>
                  <IonText color="primary" style={{ fontWeight: "bold", textDecoration: "line-through" }}>
                    <FormattedDate
                      value={lesson.to_date._seconds * 1000}
                      day="2-digit"
                      month="2-digit"
                      year="2-digit"
                      weekday="long"
                    />
                    &nbsp;-&nbsp;
                    <FormattedTime
                      value={lesson.from_date._seconds * 1000}
                    />
                  </IonText>
                </li>
              ))}
            </ul>
          </div>
        </IonCardContent>
      )}
    </IonCard>
  );
}

GroupLogCard.propTypes = {
  href: PropTypes.string,
  imageUrl: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    from_date: PropTypes.shape({ seconds: PropTypes.number }),
    full_name: PropTypes.string,
    to_date: PropTypes.shape({ seconds: PropTypes.number }),
    participants: PropTypes.array,
    fieldName: PropTypes.string,
    clubName: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    paid: PropTypes.bool,
    payment_date: PropTypes.shape({ seconds: PropTypes.number }),
    payment_channel: PropTypes.string,
    lessonList: PropTypes.arrayOf(PropTypes.object),
    minimum_lessons: PropTypes.number,
    lessons: PropTypes.number,
  }),
};

export default GroupLogCard;
